<script lang="ts">
  import type { AgencyGroupRef, AgencyRef } from '@gat-ship/types'
  import { useAgencyRefDataSource } from '../datasources/agency-ref-datasource'
  import { useAgencyGroupRefDataSource } from '../datasources/agency-group-datasource'
  import { defineStore } from 'pinia'
  import { shallowRef, toRef } from 'vue'
  import { createContext } from 'reka-ui'

  const useRefDataStore = defineStore('ref-data-store', () => {
    const agenciesRef = shallowRef<AgencyRef[] | undefined>(undefined)
    const agencyGroupsRef = shallowRef<AgencyGroupRef[] | undefined>(undefined)
    return {
      agenciesRef,
      agencyGroupsRef
    }
  })

  function defineGlobalRefData() {
    const refStore = useRefDataStore()
    const agencyRefDataSource = useAgencyRefDataSource(
      toRef(refStore, 'agenciesRef')
    )
    const agencyGroupRefDataSource = useAgencyGroupRefDataSource(
      toRef(refStore, 'agencyGroupsRef')
    )
    return {
      agenciesRef: agencyRefDataSource,
      agencyGroupsRef: agencyGroupRefDataSource
    }
  }

  const [useGlobalRefData, provideGlobalRefData] =
    createContext<ReturnType<typeof defineGlobalRefData>>('global-ref-data')

  export { useGlobalRefData }
</script>

<script setup lang="ts">
  const context = defineGlobalRefData()
  provideGlobalRefData(context)
</script>
<template>
  <slot />
</template>
